<script>
import TablePage from '@/found/components/table_page';
import ShuttleBox from '../form/shuttle_box.vue';

export default {
  extends: TablePage,
  components: {
    // Modal,
    ShuttleBox,
  },
  data() {
    return {
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        type: 'Modal',
      },
    };
  },
  mounted() {
    this.getConfigList('dms_contract_template');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'add') {
        this.modalConfig.title = '新增';
        this.formName = 'ShuttleBox';
        this.openModal();
      } else if (val.code === 'edit') {
        this.modalConfig.title = '编辑';
        this.formName = 'ShuttleBox';
        this.formConfig.code = row.code;
        this.openModal();
      }
    },
  },
};
</script>
